const form = {
  en: {
    form: {
      validation_messages: {
        empty_field_error: "{0} cannot be left empty",
        numerical_error: "{0} should be a numerical value",
        clean_string_error: "{0} should not contain special characters",
        leading_or_trailing_space_error: "{0} should not start nor end with a space",
        invalid_email_error: "{0} is an invalid email address",
        invalid_url_error: "{0} is an invalid link address",
        invalid_asian_syntax_error: "{0} contains words that must be wrapped in double quotes",
        invalid_syntax_error: "{0} has invalid syntax in value",
        invalid_brackets_error: "{0} has invalid bracket syntax in value",
        select_folder_error: "You must select a folder where to save the query",
        entry_exists: "Value already exists please try another {0}",
        is_not_unique: "{0} has to be unique",
        used: '{label} already used.',
        required: '{label} must have a value.',
        boolean_name: 'Name should not contain quotation mark (") or backslash (\\) ',
        string_max_length_error: "{0} must be less than {1} characters"
      },
      button: {
        add: '+ Add',
        confirm: 'Confirm',
        export: 'Export',
        save: 'Save',
        close: 'Close',
        cancel: 'Cancel',
        search: 'Search',
        remove: 'Remove',
        delete: 'Delete',
        submit: 'Submit',
        group: 'Group',
        edit: 'Edit',
        open: 'Open',
        clone: 'Clone',
        clear: 'Clear',
        reset: 'Reset',
        new: 'New',
        continue: 'Continue',
        upload: 'Upload',
        select_all: 'Select All',
        clear_all: 'Clear All',
        back: 'Back',
      },
      placeholder: {
        write_here: 'Write here...',
      },
      labels: {
        hours: "Hours",
        minutes: "Minutes",
        seconds: "Seconds",
        auto_translate: "Auto translate headline and summary"
      },
      multiselect:{
        import:'import (xlsx)',
        export:'export (xlsx)'
      },
      import_outlets:'Import Outlets',
      missing_ids: 'Missing Ids: ',
      tooltip: {
        select_all: "Select All (shown options only)",
        clear_selection: "Clear Selection",
        save_selection: 'Save Selection'
      }
    }
  }
}

module.exports.form = form;
